import { gql } from '@apollo/client';

export default gql`
  query {
    searchParams @client {
      __typename
      outboundDate
      inboundDate
      origin
      destination
      returningOrigin
      returningDestination
      adults
      adults12To15
      adults16Plus
      children
      children4Only
      children5To11
      infants
      youths
      seniors
    }
  }
`;
